import axios from 'axios';
import ListsManager from './ListsManager';
import API_BASE_URL from '../config';

const FLUSH_INTERVAL_MS = 60_000;
const MAX_BATCH_SIZE = 50;

class AnalyticsService {
    static baseUrl = API_BASE_URL;
    static _queue = [];
    static _flushTimer = null;
    static _sessionStart = Date.now();
    static _pageViews = {};

    static setBaseUrl(url) {
        if (url) {
            this.baseUrl = url.replace(/\/$/, "");
        }
    }

    static async getAuthHeaders() {
        const token = await ListsManager.getAuthToken();
        if (!token) return null;
        return {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        };
    }

    static _ensureFlushTimer() {
        if (this._flushTimer) return;
        this._flushTimer = setInterval(() => this.flush(), FLUSH_INTERVAL_MS);

        if (typeof window !== 'undefined') {
            window.addEventListener('beforeunload', () => this.flush());
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'hidden') this.flush();
            });
        }
    }

    static logActivity(actionType, details = {}) {
        this._ensureFlushTimer();

        if (actionType.startsWith('view_')) {
            const now = Date.now();
            const last = this._pageViews[actionType];
            if (last && now - last < 30_000) return;
            this._pageViews[actionType] = now;
        }

        this._queue.push({
            action_type: actionType,
            details,
            ts: new Date().toISOString(),
        });

        if (this._queue.length >= MAX_BATCH_SIZE) {
            this.flush();
        }
    }

    static async flush() {
        if (this._queue.length === 0) return;

        const batch = this._queue.splice(0, MAX_BATCH_SIZE);

        try {
            const headers = await this.getAuthHeaders();
            if (!headers) {
                this._queue.unshift(...batch);
                return;
            }

            await axios.post(
                `${this.baseUrl}/listeners/activity/batch`,
                { events: batch },
                { headers }
            );
        } catch (error) {
            this._queue.unshift(...batch);
            console.error('AnalyticsService: flush failed, will retry', error);
        }
    }
}

export default AnalyticsService;
